import { ProgressSpinnerDesignTokens } from '@primeuix/themes/types/progressspinner';

export const progressspinner: ProgressSpinnerDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        colorOne: '{primary.500}',
        colorTwo: '{primary.500}',
        colorThree: '{primary.500}',
        colorFour: '{primary.500}',
      },
    },
  },
};
